import { Button } from '@repo/ui/button'
import { useAsyncData } from '@repo/ui/dataProvider'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@repo/ui/dialog'
import { useT } from '@repo/ui/hooks'
import { sortByKey } from '@repo/ui/utils'
import { Loader2 } from 'lucide-react'
import { useMemo, useState } from 'react'
import { IoSparklesSharp } from 'react-icons/io5'

import { ReportGenerator } from '@/components/beneficiary/report/ReportGenerator'
import { ReportTemplate } from '@/store/report-templates/types'

interface ReportsModalProps {
  className?: string
}

export function ReportsTrigger({ className }: ReportsModalProps) {
  const { tc, t } = useT({ keyPrefix: 'reports' })
  const [isOpen, setIsOpen] = useState(false)
  const { data, isFulfilled } = useAsyncData([(state) => state.reportTemplates.reportTemplates])

  if (!isFulfilled)
    return (
      <Button variant="highlight" className={className} disabled>
        <Loader2 className="size-4 animate-spin" />
        {tc('loading')}...
      </Button>
    )

  const [reportTemplates] = data
  return (
    <>
      <Button variant="highlight" className={className} onClick={() => setIsOpen(true)}>
        <IoSparklesSharp className="size-4" />
        {t('cta')}
      </Button>
      {isOpen && (
        <ReportTemplates reportTemplates={reportTemplates} modalHandler={{ isOpen, setIsOpen }} />
      )}
    </>
  )
}

function ReportTemplates({
  reportTemplates,
  modalHandler: { setIsOpen, isOpen },
}: {
  modalHandler: { setIsOpen: (open: boolean) => void; isOpen: boolean }
  reportTemplates: ReportTemplate[]
}) {
  const { t } = useT({ keyPrefix: 'reports' })
  const sortedReportTemplates = useMemo(
    () => [...reportTemplates].sort(sortByKey('name')),
    [reportTemplates],
  )
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="max-h-[90vh] max-w-6xl overflow-y-auto">
        <DialogHeader className="flex flex-row items-center justify-between gap-2">
          <DialogTitle>{t('title')}</DialogTitle>
        </DialogHeader>
        <ReportGenerator reportTemplates={sortedReportTemplates} />
      </DialogContent>
    </Dialog>
  )
}
